import axios from 'src/lib/axios';

export const assignmentContent = (response) => response?.data?.content ?? response?.data;
export const assignmentRequestConfig = (key, respondAsync = false) => key ? {
  headers: { 'Idempotency-Key': key, ...(respondAsync && { Prefer: 'respond-async' }) },
} : undefined;

export const newAssignmentKey = () => {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  // getRandomValues also works in browsers that lack randomUUID.
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

export const getAssignmentJobs = async (signal) => assignmentContent(await axios.get('/manager/assignment-jobs/', { signal }));
export const getAssignmentJob = async (id) => assignmentContent(await axios.get(`/manager/assignment-jobs/${id}/`));
